import Vue from 'vue'
import { HTTP_DELETE, HTTP_GET, HTTP_POST, HTTP_PUT } from '../const';
import { CREATE_ACCOUNT, DELETE_ACCOUNT, LOAD_ACCOUNTS_LIST, LOAD_ACCOUNTS_NAMES } from '@/store/const/accounts';

export default {
  namespaced: true,
  state: {
    accounts: {
      list: [],
      pagination: {},
    },
    accountsNames: [],
  },
  getters: {
    accounts: state => state.accounts,
    accountsNames: state => state.accountsNames,
  },
  actions: {
    [CREATE_ACCOUNT]: async ({ dispatch }, body) => {
      return await dispatch(HTTP_POST, {
        method: CREATE_ACCOUNT,
        body,
        no_commit: true,
        namespace: 'accounts',
      }, { root: true });
    },
    [LOAD_ACCOUNTS_LIST]: async ({ dispatch }) => {
      return await dispatch(HTTP_GET, {
        method: LOAD_ACCOUNTS_LIST,
        namespace: 'accounts',
      }, { root: true });
    },
    [LOAD_ACCOUNTS_NAMES]: async ({ dispatch }) => {
      return await dispatch(HTTP_GET, {
        method: LOAD_ACCOUNTS_NAMES,
        namespace: 'accounts',
      }, { root: true });
    },
    [DELETE_ACCOUNT]: async ({ dispatch }, id) => {
      return await dispatch(HTTP_DELETE, {
        method: DELETE_ACCOUNT,
        namespace: 'accounts',
        no_commit: true,
        replace: { id },
      }, { root: true });
    },
  },
  mutations: {
    [LOAD_ACCOUNTS_LIST]: (state, { data }) => {
      Vue.set(state.accounts, 'list', data.list);
      Vue.set(state.accounts, 'pagination', data.pagination);
    },
    [LOAD_ACCOUNTS_NAMES]: (state, { data }) => {
      Vue.set(state, 'accountsNames', data);
    },
  },
};
